<script lang="ts" setup>
const { duration } = defineProps({
  duration: {
    type: Number,
    default: 300,
  },
});

const emit = defineEmits(["mouseenter", "mouseleave"]);

const timeout = ref<NodeJS.Timeout | undefined>(undefined);

const onMouseEnter = () => {
  timeout.value = setTimeout(() => {
    emit("mouseenter");
  }, duration);
};

const onMouseLeave = () => {
  if (timeout.value) {
    clearTimeout(timeout.value);
  }

  emit("mouseleave");
};
</script>

<template>
  <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <slot />
  </div>
</template>

<style scoped></style>
